import type { ReactNode } from 'react';
import { AppFooter } from '../../../components/AppFooter';
import { useT } from '../../../i18n/I18nProvider';
import { SkipLink } from '../../../ui/atoms/SkipLink';
import { PublicHeader } from './PublicHeader';

/**
 * Public chrome for every page of the area: skip link, `PublicHeader`
 * (brand home link, language select, sign-in), `<main id="main">` and the
 * footer.
 */
export function PublicShell({ children }: { children: ReactNode }) {
  const { t } = useT();

  return (
    <div className="min-h-screen bg-base-200 flex flex-col">
      <SkipLink targetId="main">{t('public.shell:skipToContent')}</SkipLink>
      <PublicHeader />
      <main
        id="main"
        tabIndex={-1}
        className="flex-1 flex items-center justify-center p-4 focus:outline-none"
      >
        {children}
      </main>
      <AppFooter />
    </div>
  );
}
